module.exports = __webpack_public_path__ + "static/media/foood-chain-blockchain-and-robotics-tablet.c5b1812f.jpg";